// extracted by mini-css-extract-plugin
export default {"error":"ZQCcZDWticnZSBuPshxc"};